module.exports = __webpack_public_path__ + "img/525-eac672.png";